import * as React from 'react';
import { Popper } from '@mui/material'
import { ConversationPanel } from '../ConversationPanel/ConversationPanel.js'
import { ConversationFab } from '../Fab/ConversationFab.js'
import { FloatingConversationApiProvider } from './components/FloatingConversationApiProvider.js'
import { useFloatingConversation } from './hooks/useFloatingConversation.js'
import type { FloatingConversationProps } from './types.js'

export function FloatingConversation(props: FloatingConversationProps) {
  return (
    <FloatingConversationApiProvider>
      <_FloatingConversation {...props} />
    </FloatingConversationApiProvider>
  )
}

function _FloatingConversation(props: FloatingConversationProps) {
  const { children } = props
  const { setFabRef, fabProps, popperProps, conversationPanelProps } = useFloatingConversation(props)

  return (
    <>
      <ConversationFab {...fabProps} ref={setFabRef} />
      <Popper {...popperProps}>
        <ConversationPanel {...conversationPanelProps}>{children}</ConversationPanel>
      </Popper>
    </>
  )
}
